package net.zagart.ai.core.client

import kotlinx.serialization.Serializable

@Serializable
data class AiChatMessage(
    val role: AiChatRole? = null,
    val content: String? = null
)
